<div class="filters mb-16 w-full" fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" fxLayoutGap.gt-sm="16px">
    <div class="module-modes w-full min-[600px]:w-fit mb-12 min-[600px]:mb-0 p-8 bg-gray-200 rounded" *ngIf="isVisibleToggleButtons">
        <mat-button-toggle-group #group="matButtonToggleGroup" appearance="legacy" [value]="modulesViewPreference || 'card'">
            <mat-button-toggle [class.selected]="group.value === 'card'" class="accent left" value="card" (click)="storeViewPreference('card')">
                <mat-icon svgIcon="list" class="mr-4"></mat-icon>
                <span class="text-sm"> {{ 'PAGE.ALL_MODULES.VIEW.CARD_VIEW' | translate }} </span>
            </mat-button-toggle>
            <mat-button-toggle [class.selected]="group.value === 'list'" class="accent right" value="list" (click)="storeViewPreference('list')">
                <mat-icon class="mr-4">list</mat-icon>
                <span class="text-sm"> {{ 'PAGE.ALL_MODULES.VIEW.LIST_VIEW' | translate }} </span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="filters-controls mt-0 sm:mt-12 md:mt-0 w-full" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="start stretch" fxLayoutAlign.gt-xs="space-between center">
        <app-tag-multi-select class="tag-filter w-full sm:w-auto mb-8 mb-sm-0" [tags]="tagService.tag$ | async" [storageKey]="tagStorageKey"></app-tag-multi-select>

        <div class="w-full sm:w-auto" fxLayout="row">
            <app-search-outline class="w-full min-[600px]:w-auto" [searchInput]="searchInput"></app-search-outline>

            <app-flat-button
                fxHide
                fxShow.gt-sm
                [icon]="'add'"
                [label]="getAddNewModuleLabel | translate"
                [routerLink]="getAddNewModuleRoute"
                *ngIf="getAddNewModuleRoute && isVisibleNewModuleButton"
                class="ml-16"
            ></app-flat-button>

            <button
                fxHide.gt-sm
                mat-icon-button
                class="min-width-auto px-8"
                [matMenuTriggerFor]="menu"
                aria-label="More"
                (click)="$event.stopPropagation()"
                *ngIf="getAddNewModuleRoute && isVisibleNewModuleButton"
            >
                <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu" xPosition="before">
                <a mat-menu-item [routerLink]="getAddNewModuleRoute">
                    <mat-icon> add_circle </mat-icon>
                    <span>{{ getAddNewModuleLabel | translate }}</span>
                </a>
            </mat-menu>
        </div>
    </div>
</div>
